import { useQuery } from '@tanstack/react-query';
import { queryKeys, partnersService } from '@v2/services';

export const usePartners = () => {
  const query = useQuery({
    queryKey: queryKeys.partners.lists(),
    queryFn: partnersService.getPartners,
  });

  return {
    partners: query.data ?? [],
    loading: query.isLoading,
    error: query.error instanceof Error ? query.error.message : null,
    refetch: query.refetch,
  };
};

export default usePartners;
